<script lang="ts" setup>
import IconButton from '@/uiKit/IconButton.vue'
import { FOOTER_Z_INDEX } from './useTableZIndices'

defineProps<{
  indexColWidth: number
}>()

defineEmits<{
  (e: 'create-entity'): void
}>()
</script>

<template>
  <div class="sticky left-0 cursor-pointer items-center border-r border-border-subtle select-none">
    <div
      class="inline-flex h-8 items-center justify-center border-t border-r border-border-subtle bg-surface-primary px-3 py-1.5 text-icon-subtlest"
      :style="{ width: `${indexColWidth}px` }"
      data-table-footer
    >
      <IconButton
        icon="plus"
        size="sm"
        aria-label="Add entity"
        variant="transparent"
        @click="$emit('create-entity')"
      />
    </div>
    <div
      class="col-start-2 col-end-[-1] inline-flex h-8 items-center justify-start border-t border-border-subtle bg-surface-primary px-3 py-1.5 text-sm-12px-default text-text-subtle"
      tabindex="0"
      role="button"
      :style="{ zIndex: FOOTER_Z_INDEX }"
      @click="$emit('create-entity')"
      @keydown.enter.stop="$emit('create-entity')"
    >
      <slot />
    </div>
  </div>
</template>
